module.exports = __webpack_public_path__ + "img/img5.317aa3bc.png";